import { useCallback } from "react";

import { useCompanionV2 } from "./use-companion-v2";

export type NoteFeedbackTriggerType = "flag" | "thumbs_down";

const TOOLTIP_CONTENT =
  "Need help fixing this note? I can rewrite sections, adjust formatting, or help you turn this into a template.";

const ACTIONS: {
  label: string;
  message: string;
  key: "rewrite" | "adjust_formatting" | "turn_into_template";
}[] = [
  {
    label: "Rewrite",
    message: "Help me rewrite sections of this note",
    key: "rewrite",
  },
  {
    label: "Adjust formatting",
    message: "Help me adjust the formatting of this note",
    key: "adjust_formatting",
  },
  {
    label: "Turn into template",
    message: "Help me turn this note into a template",
    key: "turn_into_template",
  },
];

export function useNoteFeedbackTrigger() {
  const { showCompanionTooltip } = useCompanionV2();

  const triggerNoteFeedbackPrompt = useCallback(
    (trigger: NoteFeedbackTriggerType, noteUuid?: string | null) => {
      showCompanionTooltip({
        id: `note-feedback-${trigger}`,
        companions: ["quill"],
        content: TOOLTIP_CONTENT,
        actions: ACTIONS.map((a) => ({
          label: a.label,
          message: a.message,
          key: a.key,
        })),
        tracking: {
          trigger: `note_feedback_${trigger}`,
          properties: { noteUuid: noteUuid ?? null },
        },
      });
    },
    [showCompanionTooltip],
  );

  return { triggerNoteFeedbackPrompt };
}
